import { get } from './get';
import { list } from './list';

export const workflowActivities = {
  get,
  list,
};
